import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/** Restricts a route to specific admin roles. Sends anyone else back to their
 *  normal dashboard rather than a bare permission-denied page — they're a valid
 *  admin, just not cleared for this particular screen. */
export const roleGuard = (allowedRoles: string[]): CanActivateFn => () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const role = auth.currentUser()?.role;
  if (role && allowedRoles.includes(role)) return true;

  return router.createUrlTree(['/admin/dashboard']);
};

/** Blocks specific roles from a route, redirecting them to a role-appropriate
 *  landing page instead of the normal admin dashboard — e.g. a SURVEYOR has no
 *  business on /admin/dashboard either, so bouncing everyone there like roleGuard
 *  does would just trade one wrong page for another. */
export const denyRoleGuard = (deniedRoles: string[], redirectTo: string): CanActivateFn => () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const role = auth.currentUser()?.role;
  if (role && deniedRoles.includes(role)) return router.createUrlTree([redirectTo]);

  return true;
};
